import { FormHelperText, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { formatPrice } from '../../../shared/utils/format-price.util';
import { DeliveryZoneCharge, DeliveryZoneChargeField } from '../../types/delivery-zone.type';
import { CHARGES_ERROR, CHARGES_REQUIRED_ERROR } from '../../utils/delivery-zone-charges.util';
import { DeliveryZoneCard } from './DeliveryZoneCard.component';

type Props = {
  charges: DeliveryZoneCharge[];
  isArchived: boolean;
  areChargesInvalid: boolean;
  needsCharges: boolean;
  onChargeChange: (index: number, field: DeliveryZoneChargeField, value: number) => void;
};

const useStyles = makeStyles({
  chargeRow: {
    display: 'flex',
    gap: '1rem',

    '& > *': {
      flex: 1,
    },
  },
});

export function DeliveryZoneChargesCard({
  charges,
  isArchived,
  areChargesInvalid,
  needsCharges,
  onChargeChange,
}: Props) {
  const classes = useStyles();

  return (
    <DeliveryZoneCard title="Paliers">
      {charges.map((charge, index) => (
        <div key={index} className={classes.chargeRow}>
          <TextField
            size="small"
            variant="outlined"
            type="number"
            id={`delivery-zone-threshold-${index}`}
            label={`Palier ${index + 1} : seuil (€)`}
            disabled={isArchived}
            inputProps={{ min: 0, step: 0.01 }}
            value={charge.threshold}
            onChange={(event) => onChargeChange(index, 'threshold', Number(event.target.value))}
          />
          <TextField
            size="small"
            variant="outlined"
            type="number"
            id={`delivery-zone-costs-ht-${index}`}
            label="Frais HT (€)"
            disabled={isArchived}
            inputProps={{ min: 0, step: 0.01 }}
            value={charge.costsHT}
            onChange={(event) => onChargeChange(index, 'costsHT', Number(event.target.value))}
          />
          <TextField
            size="small"
            variant="outlined"
            id={`delivery-zone-costs-ttc-${index}`}
            label="Frais TTC"
            disabled={isArchived}
            value={formatPrice(charge.costsTTC)}
            InputProps={{ readOnly: true }}
          />
        </div>
      ))}
      {needsCharges && <FormHelperText error>{CHARGES_REQUIRED_ERROR}</FormHelperText>}
      {areChargesInvalid && <FormHelperText error>{CHARGES_ERROR}</FormHelperText>}
    </DeliveryZoneCard>
  );
}
